// store/balance/createBalanceSlice.ts

import { StateCreator } from 'zustand';
import { companiesInitialState, CompaniesState } from './companiesInitialState';
import { CompanyData, QuestionnaireInfoDto } from '../../types';
import { createFunctionalSetter } from '../storeCommons';

/**
 * @french
 * Interface des actions liées aux entreprises.
 */
export interface CompaniesActions {
  setSelectedCompany: (
    updater: (CompanyData | null) | ((prev: CompanyData | null) => CompanyData | null),
  ) => void;
  setQuestionnaireList: (data: QuestionnaireInfoDto[]) => void;
  reset: () => void;
}

/**
 * @french
 * Slice Zustand pour les actions des entreprises.
 */
export const createCompaniesSlice: StateCreator<
  CompaniesState & CompaniesActions,
  [],
  [],
  CompaniesActions
> = (set, get) => ({
  setSelectedCompany: createFunctionalSetter(get, set, 'selectedCompany'),
  setQuestionnaireList: (data) => set({ questionnaireList: data }),
  reset: () => set(companiesInitialState),
});
